import { isAxiosError } from '../../isAxiosError';
import localAxios from '../../localAxios';
import { workspaceQuizLockURL } from '../workspacesURLs';

export interface WorkspaceLock {
  lockValidForRequestingUser: boolean;
  lockIsExpired: boolean;
}

interface GetWorkspaceQuizLockResponse {
  httpStatus: number;
  message: string;
  data: WorkspaceLock;
}

export type WorkspaceQuizLock = {
  lockStatus: LockStatus;
  lockIsExpired?: boolean;
};

export enum LockStatus {
  Unlocked = 'Unlocked',
  LockedByYou = 'LockedByYou',
  LockedBySomeone = 'LockedBySomeone',
}

export async function getWorkspaceQuizLock({
  workspaceId,
  workspaceQuizId,
}: {
  workspaceId: string;
  workspaceQuizId: string;
}): Promise<WorkspaceQuizLock> {
  const url = workspaceQuizLockURL({
    workspaceId,
    workspaceQuizId: workspaceQuizId,
  });
  try {
    const {
      data: {
        data: { lockValidForRequestingUser, lockIsExpired },
      },
    } = await localAxios.get<GetWorkspaceQuizLockResponse>(url.href);
    if (lockValidForRequestingUser) {
      return {
        lockStatus: LockStatus.LockedByYou,
      };
    } else if (lockIsExpired) {
      return {
        lockStatus: LockStatus.Unlocked,
      };
    } else if (!lockValidForRequestingUser && !lockIsExpired) {
      return {
        lockStatus: LockStatus.LockedBySomeone,
      };
    }
  } catch (error) {
    if (!isAxiosError(error)) {
      throw error;
    }
    if (error.response.status === 404 && error.response.data) {
      return {
        lockStatus: LockStatus.Unlocked,
      };
    }

    throw error;
  }
}
